/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { CustomerCompanyCaseDifficulty } from '../enums/customer-company-case-difficulty.enum';
import { CustomerCompanyCaseLength } from '../enums/customer-company-case-length.enum';
import { SlaTypeIndexDto } from './sla-type-index-dto';
import { InvoicingPeriod } from '../financials/enums/invoicing-period.enum';
import { DocumentDto } from './document-dto';
import { CustomerContactDto } from './customer-contact-dto';
import { CustomerUserDto } from './customer-user-dto';
import { CustomerUserInvitationIndexDto } from './customer-user-invitation-index-dto';

export class CustomerCompanyDto {
  public id: string = undefined;
  public emcId: number = undefined;
  public slaTypeId: string = undefined;
  public departmentId: string = undefined;
  public department: string = undefined;
  public name: string = undefined;
  public country: string = undefined;
  public postCode: string = undefined;
  public city: string = undefined;
  public countryCode: string = undefined;
  public caseDifficulty: CustomerCompanyCaseDifficulty;
  public caseLength: CustomerCompanyCaseLength;
  public slaType: SlaTypeIndexDto;
  public contractualRelation: boolean;
  public authorization: boolean;
  public powerOfAttorneyForDocuments: boolean;
  public powerOfAttorneyForTransits: boolean;
  public comment: string = undefined;
  public tollCredit: string = undefined;
  public phoneNumber: string = undefined;
  public address: string = undefined;
  public organizationNumber: string = undefined;
  public serialId: number = undefined;
  public invoicingPeriod: InvoicingPeriod;
  public defaultDeclarantId: string = undefined;
  public defaultCustomerContactId: string = undefined;
  public internalWorkDocument: DocumentDto;
  public externalWorkDocument: DocumentDto;
  public customerContacts: CustomerContactDto[];
  public customerUsers: CustomerUserDto[];
  public userInvites: CustomerUserInvitationIndexDto[];

  //<custom-body>
  public constructor(source: CustomerCompanyDto) {
    Object.assign(this, source);

    this.externalWorkDocument = source.externalWorkDocument ? new DocumentDto(source.externalWorkDocument) : null;
    this.internalWorkDocument = source.internalWorkDocument ? new DocumentDto(source.internalWorkDocument) : null;
  }
  //</custom-body>
}
